import { render, staticRenderFns } from "./GoodsModal.vue?vue&type=template&id=73c24788&scoped=true"
import script from "./GoodsModal.vue?vue&type=script&lang=ts"
export * from "./GoodsModal.vue?vue&type=script&lang=ts"
import style0 from "./GoodsModal.vue?vue&type=style&index=0&id=73c24788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c24788",
  null
  
)

export default component.exports